import React, { useMemo, useState } from "react";
import { formatPercent } from "../../utils/numbers/formatPercent";
import formatDollar from "../../_src_shared/utils/functions/formatDollar";
import { formatDateShort } from "../../utils/dates/formatDateShort";
import Flx from "../layout/Flx";
import {
  CheckCircleOutlineOutlined,
  RadioButtonUncheckedOutlined,
  Visibility,
  VisibilityOff,
} from "@mui/icons-material";
import { Box, IconButton, Tooltip } from "@mui/material";
import Txt from "../typography/Txt";
import { isArray, isBoolean, isNil, isObject } from "lodash";

const OverviewItem = ({
  label,
  value,
  icon,
  type,
  labelTooltip,
  stacked = true,

  showIf,
  hide,
}) => {
  const [showFullSSN, setShowFullSSN] = useState(false);

  const formatSSN = (ssn) => {
    if (!ssn) return "N/A";
    const cleanSSN = ssn.toString().replace(/\D/g, "");
    if (cleanSSN.length !== 9) return ssn; // Return as-is if not 9 digits

    return `${cleanSSN.slice(0, 3)}-${cleanSSN.slice(3, 5)}-${cleanSSN.slice(5)}`;
  };

  const maskSSN = (ssn) => {
    if (!ssn) return "N/A";
    const cleanSSN = ssn.toString().replace(/\D/g, "");
    if (cleanSSN.length < 4) return ssn;

    const lastFour = cleanSSN.slice(-4);
    const maskedPart = "*".repeat(Math.max(0, cleanSSN.length - 4));

    // Always format as XXX-XX-XXXX for 9-digit SSNs
    if (cleanSSN.length === 9) {
      return `${maskedPart.slice(0, 3)}-${maskedPart.slice(3, 5)}-${lastFour}`;
    }
    return maskedPart + lastFour;
  };

  const renderedValue = useMemo(() => {
    if (isNil(value)) {
      return "N/A";
    }

    if (isObject(value)) {
      return "Invalid Object";
    }

    if (isArray(value)) {
      return "Invalid List";
    }

    if (type) {
      if (type === "date") {
        return formatDateShort(value);
      }
      if (type === "dollar") {
        return formatDollar(value);
      }
      if (type === "percent") {
        return formatPercent(value);
      }
      if (type === "ssn") {
        return showFullSSN ? formatSSN(value) : maskSSN(value);
      }
      // if (type === "checklist") {
      //   return label;
      // }
    }
    return value;
  }, [value, type, showFullSSN]);

  const renderedIcon = useMemo(() => {
    if (icon) {
      return icon;
    }

    if (type === "checklist") {
      if (isBoolean(value)) {
        if (value) {
          return <CheckCircleOutlineOutlined className="thin-8" />;
        } else {
          return <RadioButtonUncheckedOutlined className="thin-8" />;
        }
      }
    }

    return null;
  }, [value, type, label]);

  const toggleSSNVisibility = () => {
    setShowFullSSN(!showFullSSN);
  };

  if (isBoolean(showIf) || isBoolean(hide)) {
    if (isBoolean(hide) && hide) {
      return null;
    }
    if (isBoolean(showIf) && !showIf) {
      return null;
    }
  }

  return (
    <Flx
      gap={stacked ? 0.4 : 1}
      ac={!stacked}
      column={stacked}
      sx={{
        ".MuiSvgIcon-root": {
          fontSize: "16px",
        },
        ".txt": {
          fontSize: "12px",
        },
      }}
    >
      {renderedIcon}
      {label ? (
        labelTooltip ? (
          <Tooltip title={labelTooltip}>
            <Box>
              <Txt sx={{ color: "#33475b", fontSize: 12 }}>{label}</Txt>
            </Box>
          </Tooltip>
        ) : (
          <Txt sx={{ color: "#33475b", fontSize: 12 }}>{label}</Txt>
        )
      ) : // <InputWrapper secondary sx={{ fontWeight: 500 }}>
      //   {label}
      // </InputWrapper>
      // <Txt secondary sx={{ fontWeight: 500 }}>
      //   {label}
      // </Txt>
      null}
      {/* <Txt secondary sx={{ opacity: 0.55 }}> */}
      <Txt bold>{renderedValue}</Txt>
      {type === "ssn" && (
        <IconButton
          size="small"
          onClick={toggleSSNVisibility}
          sx={{
            ml: 0.5,
            p: 0.25,
            "& .MuiSvgIcon-root": {
              fontSize: "14px",
            },
          }}
        >
          {showFullSSN ? <VisibilityOff /> : <Visibility />}
        </IconButton>
      )}
    </Flx>
  );
};
export default OverviewItem;
